import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const PrivacyPage = () => {
  const seoData = {
    title: 'Privacy Policy | CTHomeRemodels.com',
    description: 'Privacy policy for CTHomeRemodels.com and Visser General Construction LLC.',
    canonical: 'https://cthomeremodels.com/privacy'
  };

  return (
    <div className="privacy-page">
      <SEO {...seoData} />
      
      <section className="bg-[#5c0701] text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Privacy Policy</h1>
          <p className="text-xl">Last Updated: March 6, 2026</p>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="bg-white rounded-xl shadow-lg p-8 space-y-6">
            <div>
              <h2 className="text-2xl font-bold mb-4">1. Information We Collect</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                We collect information that you provide directly to us, including:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                <li>Name, email address, phone number</li>
                <li>City/location information</li>
                <li>Service inquiries and project details</li>
                <li>SMS consent for text messaging</li>
                <li>Any other information you choose to provide</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold mb-4">2. How We Use Your Information</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                We use the information we collect to:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                <li>Respond to your inquiries and provide quotes</li>
                <li>Communicate about your projects</li>
                <li>Send service updates via email or SMS (with your consent)</li>
                <li>Improve our services and website</li>
                <li>Comply with legal obligations</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold mb-4">3. SMS/Text Messaging</h2>
              <p className="text-gray-700 leading-relaxed">
                By providing your phone number and consenting to SMS communications, you agree to receive text messages from Visser General Construction LLC. Message frequency varies. Message and data rates may apply. You can opt out at any time by replying STOP to any text message. Reply HELP for assistance.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold mb-4">4. Information Sharing</h2>
              <p className="text-gray-700 leading-relaxed">
                We do not sell, rent, or share your personal information with third parties except:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                <li>With your explicit consent</li>
                <li>To comply with legal requirements</li>
                <li>With service providers who assist in our operations (email, SMS services)</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold mb-4">5. Data Security</h2>
              <p className="text-gray-700 leading-relaxed">
                We implement reasonable security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet is 100% secure.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold mb-4">6. Your Rights</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                You have the right to:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                <li>Access the personal information we hold about you</li>
                <li>Request correction of inaccurate information</li>
                <li>Request deletion of your information</li>
                <li>Opt out of marketing communications</li>
                <li>Withdraw SMS consent at any time</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold mb-4">7. Cookies and Tracking</h2>
              <p className="text-gray-700 leading-relaxed">
                Our website may use cookies and similar tracking technologies to improve user experience and analyze website traffic. You can control cookies through your browser settings.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold mb-4">8. Changes to Privacy Policy</h2>
              <p className="text-gray-700 leading-relaxed">
                We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated revision date.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold mb-4">9. Contact Us</h2>
              <p className="text-gray-700 leading-relaxed">
                If you have questions about this Privacy Policy or want to exercise your rights, please contact us:
              </p>
              <div className="mt-4 p-4 bg-gray-50 rounded-lg">
                <p className="font-medium">Visser General Construction LLC</p>
                <p className="text-gray-700">42 Gay St, Meriden, CT</p>
                <p className="text-gray-700">Phone: (203) 604-3202</p>
                <p className="text-gray-700">Email: codyvisser5@gmail.com</p>
              </div>
            </div>

            <div className="pt-6 border-t">
              <Link
                to="/"
                className="text-blue-600 hover:underline font-medium"
              >
                ← Back to Home
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPage;